/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.insights.init())

App.insights = {

  init() {
    $(".js-insights-periods")
      .off("click", "a", App.insights.update_period)
      .on("click", "a", App.insights.update_period)

    $(".js-insights-range-btn")
      .off("click", App.insights.update_range)
      .on("click", App.insights.update_range)

    if ($(".js-chart-wrapper")[0]) {
      $(document)
        .off("change", ".js-group-switcher")
        .on("change", ".js-group-switcher", App.insights.update_group)

      return App.insights.update_urls($(".js-chart-wrapper").data("url"))
    }
  },

  update_group(evt) {
    evt.preventDefault()
    const url = $(".js-chart-wrapper").data("url")
    const group_id = $(this).val()
    const group_name = $(this).find("option:selected").data("name")

    if (url != null) {
      const new_url = url.replace(/groups\/\d+\//i, `groups/${group_id}/`)
      return App.insights.request_data(new_url)
    }
  },

  update_period(evt) {
    evt.preventDefault()
    const $el = $(evt.target)

    $(".js-insights-periods a").removeClass("active")
    $el.addClass("active")

    const period = $el.text().toLowerCase().trim()
    const url = new URL($(".js-chart-wrapper").data("url"))
    url.searchParams.set("period", period)
    return App.insights.request_data(url.toString())
  },

  // Update the browser url via history.pushState
  // Update sidebar group urls with appropriate params
  update_urls(chart_url) {
    const url = new URL(chart_url)
    const browser_url = new URL(
      url.toString()
        .replace(/\.js(on)?$/, "")
        .replace(/\.js(on)?\?/, "?")
    )
    history.pushState({}, "", browser_url.toString())

    const params = url.search
    return $(".js-sidebar-group-link").each(function () {
      const $a = $(this)
      $a.removeAttr("data-remote")
      const href = $a.attr("href")
      const matches = href.match(/groups\/\d+\//i)

      if (matches) {
        browser_url.search = params
        const group_id = matches[0]
        const new_href = browser_url.toString().replace(/groups\/\d+\//i, group_id)
        return $a.attr("href", new_href)
      }
    })
  },

  update_range(evt) {
    evt.preventDefault()
    const $wrapper = $(evt.target).closest(".dropdown-select")
    const $starts_on = $wrapper.find(".js-insights-starts-on")
    const $ends_on = $wrapper.find(".js-insights-ends-on")
    const starts_on_label = $starts_on.val()
    const ends_on_label = $ends_on.val()
    const starts_on_value = $starts_on.pickadate("_hidden").value
    const ends_on_value = $ends_on.pickadate("_hidden").value

    if (starts_on_value && ends_on_value) {
      $(".js-insights-range-display").text(`${starts_on_label} - ${ends_on_label}`)
      const url = new URL($(".js-chart-wrapper").data("url"))
      url.searchParams.set("starts_on", starts_on_value)
      url.searchParams.set("ends_on", ends_on_value)

      $('.js-insights-range-dropdown').removeClass('show-menu')

      return App.insights.request_data(url.toString())
    }
  },

  request_data(url) {
    // make sure chart element retains latest url
    $(".js-chart-wrapper").data("url", url)
    App.busy.start()

    $.get(url)
    return App.insights.update_urls(url)
  },

  update_data(data) {
    if (typeof data === "string") { data = JSON.parse(data.trim()) }

    if (data === null) {
      $('.js-insights-chart').empty()
      $('.js-no-data-notice').show()
      App.insights.update_footer(null)

    } else {
      $('.js-no-data-notice').hide()
      App.insights.update_chart(data.chart_data)
      App.insights.update_footer(data.footer_boxes)
    }

    return App.busy.done()
  },

  update_table(container, data) {
    $(container).replaceWith(data)
    return App.busy.done()
  },

  update_footer(data) {
    return $(".js-insights-footer-box").each(function (i) {
      const $footer_box = $(this)
      if (data) { $footer_box.find(".title").text(data[i].title) }
      return $footer_box.find(".value").text(data ? data[i].value : '0')
    })
  },

  update_chart(data) {
    if (data === null) { return }

    const $wrapper = $(".js-chart-wrapper")
    const type = $wrapper.data('type')
    const stacked = $wrapper.data('stacked')
    const y_axis_type = type === 'Area' ? 'logarithmic' : 'linear'

    return new Chartkick[`${type}Chart`]("insights-chart",
      data, {
        stacked,
        colors: ["rgba(201, 231, 252, 0.5)", "rgba(71, 150, 36, 0.35)", "rgba(244, 113, 47, 0.5)"],

        library: {
          elements: {
            line: {
              cubicInterpolationMode: 'monotone'
            }
          },
          scales: {
            yAxes: [{
              type: y_axis_type,
              ticks: {
                callback(label, index, labels) {
                  return label
                }
              }
            }]
          },
          tooltips: {
            callbacks: {
              label(item, data) {
                return `${item.yLabel} ${data.datasets[item.datasetIndex].label}`
              },
              title(item, data) {
                return `${data.labels[item[0].index]}:`
              }
            }
          }
        }
      }
    )
  }
}
